/**
 * @itemgo/service-middlemile
 * ItemGo Service Middle Mile Plugin
 */

import { middlemileManifest } from "./manifest.js";
import type { PluginModule } from "@itemgo/core";
import { calculateMiddleMilePricing } from "./services/pricing.js";
import { useMiddleMilePricing } from "./hooks/useMiddleMilePricing.js";
import { MiddleMilePricingBreakdown } from "./components/MiddleMilePricingBreakdown.js";

export { middlemileManifest };

export const middlemilePlugin: PluginModule = {
  manifest: middlemileManifest,
  services: {
    calculatePrice: calculateMiddleMilePricing as unknown as (params: unknown) => Promise<unknown>,
  },
  hooks: {
    usePricing: useMiddleMilePricing as unknown as () => unknown,
  },
  components: {
    PriceCalculator: MiddleMilePricingBreakdown as unknown as React.ComponentType<unknown>,
  },
};

// Types
export type {
  MiddleMilePricingConfig,
  MiddleMilePricingInput,
  MiddleMilePricingResult,
  MiddleMileServiceData,
} from "./types.js";

// Schema
export { middlemileSchema, serviceSubtypes } from "./schema.js";
export type { MiddleMileFormData } from "./schema.js";

// Services
export {
  calculateMiddleMilePricing,
  formatPence,
  DEFAULT_MIDDLEMILE_PRICING_CONFIG,
} from "./services/pricing.js";

// React Hooks
export { useMiddleMilePricing } from "./hooks/useMiddleMilePricing.js";

// React Components
export { MiddleMilePricingBreakdown } from "./components/MiddleMilePricingBreakdown.js";
